module.exports = __webpack_public_path__ + "static/media/Sidebar__logo.e24e3a80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sidebar__logo.svg
// module id = 507
// module chunks = 0